import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewContactus from "../../components/Contactus/ViewContactus";

const ViewContactusPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="Contact Us" title2="Contact Us" link2="/contactus" title="View Contact Us" />

        {/* AddUserLayer */}
        <ViewContactus />


      </MasterLayout>
    </>
  );
};

export default ViewContactusPage;
